import { useMap } from "react-map-gl"
import { useMemo, useEffect, useState } from "react"

export const useMapBounds = () => {
  const { current: map } = useMap()
  const [currentBounds, setCurrentBounds] = useState()
  const [isMoving, setIsMoving] = useState(false)

  useEffect(() => {
    const updateBounds = () => {
      setCurrentBounds(map.getBounds())
      setIsMoving(false)
    }

    const startMoving = () => {
      setIsMoving(true)
    }

    // Listen for move start and move end events
    map.on("movestart", startMoving)
    map.on("moveend", updateBounds)

    // Cleanup event listeners when component unmounts
    return () => {
      map.off("movestart", startMoving)
      map.off("moveend", updateBounds)
    }
  }, [map])

  const value = useMemo(
    () => ({
      bounds: isMoving ? null : currentBounds,
      isMoving: isMoving,
    }),
    [isMoving, currentBounds]
  )

  return value
}
